export default "__VITE_ASSET__CpPMa_$t__"